import React, { useState } from 'react'
import Popup from "reactjs-popup";
import { useTranslate } from './TranslationText';
import axiosInstance from '../axios/axios';
import SubmitServiceBtn from './servicesButtons/SubmitServiceBtn';
import DraftBtn from './servicesButtons/DraftBtn';
import { eFormButtonsContainer } from '../common/cssclasses';
import NetaqInput from './NetaqInput';
import { isEmpty } from 'lodash';
import { useLocation } from 'react-router';
const BaseURL = process.env.REACT_APP_BASE_URL;

export default function ServiceFeedBack({ serviceId, setShowPopUp, showPopUp, toast }) {
    const { translate } = useTranslate();
    const [feedbackFace, setFeedbackFace] = useState('');
    const [comment, setComment] = useState("");
    const location = useLocation();


    function validateRate() {
        if (isEmpty(feedbackFace)) {
            toast.error(translate('web.pleaseChooseIcon', 'Please Choose Icon'));
            return false;
        } else {
            return true;
        }
    }

    async function sendFeedBack() {


        const isVaild = validateRate();
        if (!isVaild) {
            return;
        }
        else {
            const res = await axiosInstance.post('/ServicesRequests/SubmitFeedback', { rate: feedbackFace, comment: comment, serviceId: serviceId });

            if (res.status == 200) {
                toast.success(translate('web.thankyouforfeedBack', 'Thank you for FeedBack'));
                // delete service ID From Link 
                const url = new URL(window.location.href);
                url.searchParams.set('serviceId', "");
                window.history.replaceState(null, '', url.toString());

                setShowPopUp(false);

            }
        }

    }

    return (
        <Popup
            modal
            lockScroll
            open={showPopUp}
            closeOnDocumentClick={false}
            closeOnEscape
            overlayStyle={{ zIndex: 5000 }}
            contentStyle={{ maxWidth: 800 }}
        >
            < h4 className='fw-bold text-center mb-main'>
                {translate('web.CustomerSatisfaction', 'Customer Satisfaction')}
            </h4>
            <div className='d-flex justify-content-around mb-main'>
                <img alt='bad' title={translate('web.bad', 'Bad')} style={{ transition: 'all 500ms', height: 80, cursor: 'pointer', transform: `scale(1.${feedbackFace == 'NotSatisfied' ? '2' : '0'})` }} onClick={() => { setFeedbackFace('NotSatisfied') }} src={`${BaseURL}/assets/img/bad.png`} />
                <img alt='normal' title={translate('web.normal', 'normal')} style={{ transition: 'all 500ms', height: 80, cursor: 'pointer', transform: `scale(1.${feedbackFace == 'Satisfied' ? '2' : '0'})` }} onClick={() => { setFeedbackFace('Satisfied') }} src={`${BaseURL}/assets/img/normal.png`} />
                <img alt='good' title={translate('web.good', 'good')} style={{ transition: 'all 500ms', height: 80, cursor: 'pointer', transform: `scale(1.${feedbackFace == 'VerySatisfied' ? '2' : '0'})` }} onClick={() => { setFeedbackFace('VerySatisfied') }} src={`${BaseURL}/assets/img/good.png`} />
            </div>
            <div className='row'>
                <div className='col-12'>
                    <NetaqInput
                        name='feedback'
                        type='textarea'
                        label={translate('web.feedback', 'Feedback')}
                        placeholder={translate('web.feedbackhint', 'Feedbackhint')}
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                    />
                </div>
            </div>
            <div className={eFormButtonsContainer}>
                <DraftBtn
                    onClick={() => {
                        setShowPopUp(false)
                    }}
                    text={translate('web.close', 'Close')}
                />

                <SubmitServiceBtn key={'submit'} onClick={() => (sendFeedBack())} />
            </div>
        </Popup>
    )
}
